import clsx from 'clsx';
import { IconButton } from '../Button';
import { useModalPage } from './hooks';
import { ModalBody, ModalContainer, ModalContainerProps } from '../Modal/components';

export interface ModalPageProps extends Omit<ModalContainerProps, 'isOpen'> {
  children: React.ReactNode;
  useModalPageReturn: ReturnType<typeof useModalPage>;
}

export function ModalPage({ children, className, containerMotionProps, useModalPageReturn, ...props }: ModalPageProps) {
  return (
    <ModalContainer
      isOpen={useModalPageReturn.isOpen}
      containerMotionProps={{ layoutScroll: true, ...containerMotionProps }}
      className={clsx('flex justify-center py-[124px] px-6 overflow-y-auto', className)}
      {...props}
    >
      <ModalBody className="!relative h-auto min-h-[calc(100dvh_-_40px)] !p-0 w-full max-w-[1016px] !bg-darkMode-gray-dark !grid grid-rows-[1fr_auto]">
        <div className="absolute -top-7 left-2 mx-auto right-auto">
          <IconButton
            icon="close"
            theme="secondary"
            onClick={() => useModalPageReturn.setIsOpen(false)}
            className="absolute -top-4 left-0 mx-auto right-auto"
          />
        </div>
        {children}
      </ModalBody>
    </ModalContainer>
  );
}
